import { cnpj, cpf } from 'cpf-cnpj-validator'

export default taxId => {
  if (!taxId) return '-------'

  if (cpf.isValid(taxId)) {
    return cpf.format(taxId)
  } if (cnpj.isValid(taxId)) {
    return cnpj.format(taxId)
  }

  return taxId
}
